export default __webpack_public_path__ + "static/media/logo-toyota.a4dac754.svg";